











//
// WARNING
// This file is auto-generated by Queries.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Queries.tst.
//

import { Type, Transform } from "class-transformer";
import { CancelToken } from 'axios'
import * as moment from 'moment'
import * as qrs from '@/modules/qrs'

import {
    Query,
    IPaginatedQuery, SearchDirection, ProtectedMemory,
    QueryExecutor, PaginatedQueryExecutor
} from '@/modules/qrs'

import {
    IOrderableQuery, IOrderByDescriptor, IOrderBySelectorFn, OrderByConfig, IOrderableProperties,
    OrderableQueryExecutor, OrderablePaginatedQueryExecutor
} from '@/modules/qrs/extensions/orderable'


    

    @Query('UserQuery')
    
    export class UserQuery  {
        constructor( userId: number ) {
            
                this.userId = userId;
            
        }

        
            
            public userId: number;
        

        

        

        
            /**
            * Returns an instance of a simple QueryExecutor for this query.
            */
            public static getExecutor( query?: UserQuery ) {
                return new QueryExecutor<UserQuery, UserResult>(UserResult, query);
            }

            

            
        
    }

    

    
        /**
        * The result model for UserQuery.
        */
        export class UserResult {
            
                
                 userId: number;
            
                
                 isAdmin: boolean;
            
        }
    

    /**
    * Extraneous types
    */
    export namespace UserQuery.ExtraneousTypes {
        

        
    }

